/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Lookup, LookupValue } from '../api/types/types';

/**
 * Get a lookup by name from the lookups response
 */
export const getLookupByName = (lookups: Lookup[], name: string): Lookup | undefined => {
  return lookups.find((lookup) => lookup.name === name);
};

/**
 * Get a lookup value by value number from a specific lookup
 */
export const getLookupValueByValue = (lookup: Lookup, value: number): LookupValue | undefined => {
  return lookup.values.find((lookupValue) => lookupValue.value === value);
};

/**
 * Get the label for an activity type value from the ActivityType lookup
 */
export const getActivityTypeLabel = (lookups: Lookup[], activityType: number): string => {
  const activityTypeLookup = getLookupByName(lookups, 'ActivityType');
  if (!activityTypeLookup) {
    return 'Unknown';
  }

  const typeValue = getLookupValueByValue(activityTypeLookup, activityType);
  return typeValue?.label || 'Unknown';
};
